import Episode from '../../../domain/entities/Episode';

import NetEpisodesRepository from '../../../data/repositories/NetEpisodesRepository';

export default function action(id: number): Promise<Episode> {
  const repository = new NetEpisodesRepository();
  return repository.find(id);
}
